import { useEffect, useState } from "react";

/** wide: the 860 modal · mid: 600-899, narrower paper · sheet: under 600. */
export type TitleLayout = "wide" | "mid" | "sheet";

export function layoutForWidth(width: number): TitleLayout {
  return width >= 900 ? "wide" : width >= 600 ? "mid" : "sheet";
}

export function useTitleLayout(override?: TitleLayout): { layout: TitleLayout; width: number } {
  const [width, setWidth] = useState(() => (typeof window === "undefined" ? 1200 : window.innerWidth));
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return { layout: override ?? layoutForWidth(width), width };
}
